// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1-7MR","footer":"ModalUpdate_footer__1eTxw"};